import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { Editor, Range } from "@tiptap/core";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

import type { AddToLocalSgidToObjectMap } from "./types";

export const useCreateEmbed = ({
  editor,
  range,
  addToLocalSgidToObjectMap,
}: {
  editor: Editor;
  range: Range;
  addToLocalSgidToObjectMap: AddToLocalSgidToObjectMap;
}) => {
  const toast = useToast();
  const drawer = useModal();
  return useMutation({
    mutationFn: (url: string) =>
      reactQueryPost(
        internalApi.richTextFields.createOembed({ params: { url } }),
      ),
    onSuccess: data => {
      if (!data?.oembed) {
        return toast.error(t("courses.edit.lesson.embed_failed"));
      }
      editor
        .chain()
        .focus()
        .insertContentAt(range, {
          type: "embed",
          attrs: {
            sgid: data.sgid,
          },
        })
        .run();
      addToLocalSgidToObjectMap({ sgid: data.sgid, object: data.oembed });
      drawer.remove();
    },
    onError: (_, url) => {
      if (typeof url !== "string") {
        return;
      }
      editor
        .chain()
        .focus()
        .insertContentAt(range, {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: url,
              marks: [
                {
                  type: "link",
                  attrs: { href: url, target: "_blank" },
                },
              ],
            },
          ],
        })
        .run();
      drawer.remove();
    },
  });
};
